import { useTenant } from '@parcel2go/npm-p2g-app';
import React from 'react';
import { ParcelReference } from '~/lib/types/tracking-types';
import LocalTrackingInfo from './local-tracking-info';
import NeedHelp from './need-help';
import Feedback from './feed-back';
import AnotherParcel from './another-parcel';
import { P2GGrid } from '@parcel2go/core-ui';
import { PublicSettings } from '~/lib/ui-serverless-settings';

interface IInformationCardsProps {
  showFeedback: boolean;
  metadata?: { [name: string]: string } | null;
  trackingNumber: string;
  parcelReferences: ParcelReference[];
  deliveryPostcode: string | null;
  keyEvents: { [name: string]: string };
  showLocalTracking: boolean;
}

export const InformationCards: React.FC<IInformationCardsProps> = (props: IInformationCardsProps) => {
  const { settings } = useTenant();

  const shouldDisplay = React.useMemo(() => {
    return (
      props.keyEvents['Entered Customs'] ||
      props.keyEvents['Left Customs'] ||
      props.keyEvents['Left Origin Country'] ||
      props.keyEvents['Held Customs']
    );
  }, [props.keyEvents]);

  const localTrackingLink = React.useMemo(() => {
    if (!props.metadata || !props.metadata['ExternalTrackingUrl']) {
      return null;
    }

    return Object.entries(props.parcelReferences).reduce(
      (rawUrl, [, value]) => {
        return rawUrl.replace(`{${value.type}}`, value.reference);
      },
      props.metadata['ExternalTrackingUrl']
        .replace('{Postcode}', props.deliveryPostcode || '')
        .replace('{CollectionDate}', props.keyEvents['Collected']?.split('T')[0] || '')
    );
  }, [props.deliveryPostcode, props.keyEvents, props.metadata, props.parcelReferences]);

  const websiteUrl = settings[PublicSettings.WEBSITE] ?? '';
  const supportUrl = `${websiteUrl}/help-centre`;

  const feedbackUrl = React.useMemo(() => {
    return props.metadata ? props.metadata['CustomerSurveyLink'] : undefined;
  }, [props.metadata]);

  return (
    <P2GGrid item container spacing={2}>
      {localTrackingLink && props.showLocalTracking && shouldDisplay && (
        <P2GGrid item sm={6} xs={12}>
          <LocalTrackingInfo localTrackingLink={localTrackingLink} />
        </P2GGrid>
      )}
      <P2GGrid item sm={6} xs={12}>
        <AnotherParcel />
      </P2GGrid>
      <P2GGrid item sm={6} xs={12}>
        <NeedHelp adviceUrl={supportUrl} />
      </P2GGrid>
      {props.showFeedback && (
        <P2GGrid item sm={6} xs={12}>
          <Feedback feedbackUrl={feedbackUrl} />
        </P2GGrid>
      )}
    </P2GGrid>
  );
};
